import { Routes } from '@angular/router';

import { internalNonProductionGuard } from '@advania-cosoftware/wolf-core';
import { itFinancialV2Segments } from '@advania-cosoftware/wolf-router';

export const itFinancialV2Routes: Routes = [
    {
        path: itFinancialV2Segments.itFinancialV2,
        canActivate: [internalNonProductionGuard],
        canActivateChild: [internalNonProductionGuard],
        loadComponent: () =>
            import('./features/it-financial-v2-page/it-financial-v2.page').then((m) => m.ItFinancialV2Page),
        children: [
            { path: '', pathMatch: 'full', redirectTo: itFinancialV2Segments.overview },
            {
                path: itFinancialV2Segments.overview,
                loadComponent: () =>
                    import('./features/overview/financial-overview.page').then((m) => m.FinancialOverviewPage),
            },
            {
                path: itFinancialV2Segments.changes,
                loadComponent: () =>
                    import('./features/changes/financial-changes.page').then((m) => m.FinancialChangesPage),
            },
            {
                path: itFinancialV2Segments.services,
                loadComponent: () =>
                    import('./features/services/financial-services.page').then((m) => m.FinancialServicesPage),
            },
            {
                path: itFinancialV2Segments.openItems,
                loadComponent: () =>
                    import('./features/open-items/financial-open-items.page').then((m) => m.FinancialOpenItemsPage),
            },
            ...(
                [
                    ['invoices', itFinancialV2Segments.invoices],
                    ['invoiceItems', itFinancialV2Segments.invoiceItems],
                    ['accounts', itFinancialV2Segments.accounts],
                ] as const
            ).map(([kind, path]) => ({
                path,
                data: { kind },
                loadComponent: () =>
                    import('./features/financial-list/financial-list.page').then((m) => m.FinancialListPage),
            })),
        ],
    },
];
